<template>
  <v-card elevation="0" width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="marketplacePercentage">
      <v-row align="end" class="ma-0">
        <v-col cols="12" sm="12" md="6" lg="6">
          <label class="ml-1 mb-2 label-details">Porcentagem que imprimax receberá sobre as vendas das revendas</label>
          <v-text-field
              style="border: 1px solid #979797; border-radius: 7.5px"
              color="black"
              maxlength="3"
              v-mask="'###'"
              background-color="#F5F5F5"
              outlined
              prefix="%"
              :rules="[rules.required, rules.maxValue]"
              hide-details
              required
              v-model="howMuchDecofitOnResaleSalesPercentage.percentage"
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="6">
          <label class="ml-1 mb-2 label-details">Id do recebedor cadastrado na Pagar.me</label>
          <v-text-field
              style="border: 1px solid #979797; border-radius: 7.5px"
              color="black"
              background-color="#F5F5F5"
              outlined
              :rules="[rules.required]"
              hide-details
              required
              v-model="howMuchDecofitOnResaleSalesPercentage.idReceiver"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";

export default {
  name: "MarketplacePercentage",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    outlined: true,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    },
    apiService: new ApiService(),
    dialog: false,
    howMuchDecofitOnResaleSalesPercentage: {
      id: null,
      percentage: null,
      idReceiver: null
    },
    rules: {
      required: (value) => !!value || "Campo requerido.",
      maxValue: (v) => v <= 100 || "Maximo 100.",
    },
  }),
  async created() {
    await this.getHowMuchDecofitOnResaleSales();
  },
  methods: {
    async getHowMuchDecofitOnResaleSales() {
      await this.apiService.get("howmuchdecofitonresalesales/get-one").then((response) => {
        if (response.body !== "") {
          this.howMuchDecofitOnResaleSalesPercentage = response
        }
      });
    },
    async getReceiver() {
     try {
       const response = await this.apiService.get(`resale/receiver/${this.howMuchDecofitOnResaleSalesPercentage.idReceiver}`)
       const {content} = response
       return !!(content && content.status && content.status === "active");
     } catch (e) {
       return false
     }
    },
    async validate() {
      if (!this.$refs.marketplacePercentage.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite o valor do frete padrão das revendas e/ou Id do recebedor cadastrado na Pagar.me",
          trace: null,
        });
        return
      }
      const receiver = await this.getReceiver()
      if(!receiver) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "O recebedor não está cadastrado ou está inativo.",
          trace: null,
        });
        return
      }
      this.dialog = true;
    },
    async submit() {
      try {
        let urlMethod = "howmuchdecofitonresalesales/edit"
        let httpMethod = 'put'
        if (!this.howMuchDecofitOnResaleSalesPercentage.id) {
          urlMethod = 'howmuchdecofitonresalesales/add'
          httpMethod = 'post'
          delete this.howMuchDecofitOnResaleSalesPercentage.id
        }

        this.apiService[httpMethod](urlMethod, this.howMuchDecofitOnResaleSalesPercentage)
            .then((resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "Porcentagem",
                message: resp.message,
                trace: null,
              });

              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro",
                message: err.body.message,
                trace: null,
              });
              this.dialog = false;
              this.loading = false;
            });

      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
